"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureLogItemSchema = exports.SIGNATURE_EXTRA_KEYS = exports.SIGNATURE_DEBIT_KEY = exports.SIGNATURE_EXEMPT_METHODS = exports.APosPaymentSignatureSchema = exports.APosSignatureStatusSchema = void 0;
exports.isSignatureRequired = isSignatureRequired;
const zod_1 = require("zod");
/**
 * CUSTOMER-DISPLAY SIGNATURES — one record per payment leg.
 *
 * Captured on OUR customer display, never on the NMI/Dejavoo device, so the
 * record does not depend on a processor. `s3Key` is filled in later by
 * pos-sales-service `POST /transactions/{id}/signature` once the till's outbox
 * uploads the PNG; a leg can therefore be `captured` with no key yet
 * ("signature pending upload").
 */
exports.APosSignatureStatusSchema = zod_1.z.enum(['captured', 'skipped', 'not_required']);
exports.APosPaymentSignatureSchema = zod_1.z.object({
    status: exports.APosSignatureStatusSchema,
    capturedAt: zod_1.z.number().int().optional(),
    skippedBy: zod_1.z.object({ employeeId: zod_1.z.string(), name: zod_1.z.string() }).optional(),
    s3Key: zod_1.z.string().optional(),
});
/**
 * Methods a signature is never asked for, whatever the register map says.
 *
 * SPLIT is exempt because it is not a tender: it is a sale paid with several,
 * and each leg is signed for on its own terms. Asking once for the whole
 * would produce one signature covering payments the customer made separately.
 *
 * CASH used to be here, on the reasoning that a signature backs a card
 * chargeback and there is no chargeback on cash. True, but not the only
 * reason to ask — a merchant may want one on a cash sale for their own
 * records. It is now a per-register choice like any other method, and
 * DEFAULT OFF: no register carries `signatureRequired.cash` today, so
 * removing the exemption changes nothing until somebody switches it on.
 */
exports.SIGNATURE_EXEMPT_METHODS = ['split'];
/**
 * `signatureRequired.debit` — the signature asked after a CARD payment where
 * the customer chose DEBIT at the credit/debit prompt. It is not a payment
 * method: the card tender's own key (e.g. `credit_dejavoo`) keeps meaning the
 * CREDIT rail. Missing = false, like every other key.
 */
exports.SIGNATURE_DEBIT_KEY = 'debit';
/** Keys a `signatureRequired` map may carry beyond the payment method ids. */
exports.SIGNATURE_EXTRA_KEYS = [exports.SIGNATURE_DEBIT_KEY];
/**
 * Whether a register's `paymentTypes.signatureRequired` map asks for a
 * signature on `method`. A missing map or key means false; cash and split are
 * never honoured; only an explicit `true` counts.
 */
function isSignatureRequired(map, method) {
    if (!map || typeof map !== 'object')
        return false;
    if (exports.SIGNATURE_EXEMPT_METHODS.includes(method))
        return false;
    if (!Object.prototype.hasOwnProperty.call(map, method))
        return false;
    return map[method] === true;
}
/**
 * One row of `GET /reports/signatures`. Missing register/employee details are
 * served as '' (never undefined) so a table cell always has a string.
 */
exports.SignatureLogItemSchema = zod_1.z.object({
    transactionId: zod_1.z.string(),
    paymentId: zod_1.z.string(),
    timestamp: zod_1.z.number().int(),
    status: exports.APosSignatureStatusSchema,
    method: zod_1.z.string(),
    cardLabel: zod_1.z.string(),
    amount: zod_1.z.number(),
    employeeId: zod_1.z.string(),
    employeeName: zod_1.z.string(),
    registerId: zod_1.z.string(),
    registerName: zod_1.z.string(),
});
//# sourceMappingURL=pos-signature.schema.js.map